import {
  HELP_ENTERPRISE_URL,
  HELP_TEAMS_URL,
  HELP_URL
} from '@dtx-company/true-common/src/constants/help'

export const SIDE_NAV_WIDTH = 196
export const NAV_HELP_LINK = HELP_URL
export const NAV_HELP_LINK_ENTERPRISE = HELP_ENTERPRISE_URL
export const NAV_HELP_LINK_FLOWTEAMS = HELP_TEAMS_URL
export const INTERCOM_NAV_HELP_LINK = 'https://intercom.help/flowcode/en/'
